/*
 * @Author: Json Chen
 * @Date: 2021-06-25 14:07:11
 * @LastEditTime: 2021-07-30 10:41:32
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeAdvancedModalForm.tsx
 */

import React from 'react';
import { Form, Input, Modal, Radio, Checkbox } from 'antd';
import InputMaxLength from '@/src/pages/Settings/Components/InputMaxLength';
import styles from '../style.module.less';
import useResetFormOnCloseModal from '@/src/hooks/useResetFormOnCloseModal';
import { randomNumber } from '@/src/tools/helper';
import ProductAttributeDropdownOptions from './ProductAttributeDropdownOptions';
import ShowExistValue from './ShowExistValue';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const PriceTierModalForm = ({
  visible,
  attrData,
  attrIndex,
  onCancel,
  onModalConfirm,
}: {
  // 弹窗是否展示
  visible: boolean;
  // 编辑时,默认的内容
  attrIndex: number;
  // 关闭弹窗
  onCancel: () => void;
  onModalConfirm: (data: any) => void;
  attrData: any;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [form] = Form.useForm();
  const [modalTitle, setModalTitle] = React.useState<string>('');
  const [confirmDisable, setConfirmDisable] = React.useState<boolean>(false);
  const {
    title = getI18n('storeProductSetting.detail.attribute'),
    fieldType = 'Dropdown',
    unique = false,
    options = [],
    inputKey = 'value',
    newOptionName = getI18n('storeProductSetting.detail.attributeOptions'),
  } = attrData[attrIndex] || {};

  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onOk = () => {
    form.validateFields().then((res) => {
      if (attrIndex === -1) {
        onModalConfirm(
          attrData.concat({
            ...res,
            draggableId: randomNumber(),
            deletable: true,
          }),
        );
      } else {
        onModalConfirm(
          attrData.map((item, index) => {
            if (attrIndex === index) {
              return { ...item, ...res, draggableId: randomNumber() };
            }
            return item;
          }),
        );
      }
    });
  };
  React.useEffect(() => {
    if (visible) {
      if (attrIndex === -1) {
        setModalTitle(getI18n('storeProductSetting.detail.addattribute'));

        form.setFieldsValue({
          title: `${title} ${attrData.length + 1}`,
          fieldType: fieldType,
          unique: unique,
          options: [
            {
              [inputKey]: `${newOptionName} ${(options || []).length + 1}`,
              draggableId: randomNumber(),
              deletable: true,
            },
          ],
        });
      } else {
        setModalTitle(getI18n('storeProductSetting.detail.editAttribute'));

        form.setFieldsValue({
          title: title,
          unique: unique,
          fieldType: fieldType,
          options: (options || []).map((item) => ({
            ...item,
            draggableId: randomNumber(),
          })),
        });
      }
    }
  }, [visible]);

  const addOption = () => {
    const currentOptions = form.getFieldValue('options');

    form.setFieldsValue({
      options: currentOptions.concat({
        [inputKey]: `${newOptionName} ${currentOptions.length + 1}`,
        deletable: true,
        draggableId: randomNumber(),
      }),
    });
  };

  return (
    <Modal
      forceRender={true}
      title={modalTitle}
      visible={visible}
      okButtonProps={{
        disabled: confirmDisable,
      }}
      okText={getI18n('general.confirm')}
      cancelText={getI18n('general.cancel')}
      maskClosable={false}
      width={600}
      wrapClassName={styles.modalContainer}
      onOk={onOk}
      onCancel={onCancel}>
      <Form
        form={form}
        layout='vertical'
        name='productAttrAdvancedModalForm'
        className={styles.productAttrModalForm}>
        <Form.Item
          name='title'
          className={styles.input}
          label={
            <div className={styles.inputLabel}>
              <div className={styles.inputLableTitle}>
                {getI18n('storeProductSetting.detail.attributeTitle')}*
              </div>
              <InputMaxLength maxLength={50} fieldName='title' />
            </div>
          }
          rules={[
            {
              required: true,
              message: 'Attribute Title Cannot Empty',
            },
            {
              validator: (_, value) => {
                const hasSame = attrData
                  .filter((p, i) => i !== attrIndex)
                  .some((p, i) => p.title === value);
                // 设置confirm disable
                setConfirmDisable(hasSame || !value);
                return hasSame
                  ? Promise.reject(
                      new Error(
                        'An attribute already exists with the same title.',
                      ),
                    )
                  : Promise.resolve();
              },
            },
          ]}>
          <Input size='large' maxLength={50} />
        </Form.Item>

        <Form.Item
          name='fieldType'
          className={styles.radio}
          initialValue={`Dropdown`}
          label={
            <div className={styles.radioLabel}>
              <div className={styles.radioLableTitle}>
                {getI18n('storeProductSetting.detail.attributeFieldType')}
              </div>
            </div>
          }>
          {attrIndex === -1 ? (
            <Radio.Group>
              <Radio value='Dropdown'>
                {' '}
                {getI18n('storeProductSetting.detail.dropdown')}
              </Radio>
              <Radio value='InputField'>
                {' '}
                {getI18n('storeProductSetting.detail.inputfield')}
              </Radio>
            </Radio.Group>
          ) : (
            <ShowExistValue />
          )}
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(p, c) => p.fieldType !== c.fieldType}>
          {({ getFieldValue }) => {
            const fieldType = getFieldValue('fieldType');
            switch (fieldType) {
              case 'Dropdown':
                return (
                  <ProductAttributeDropdownOptions
                    {...{
                      inputKey,
                      setConfirmDisable,
                      addOption,
                    }}
                  />
                );

              case 'InputField':
                return (
                  <Form.Item
                    name='unique'
                    valuePropName='checked'
                    className={styles.checkbox}>
                    <Checkbox disabled={attrIndex !== -1}>
                      <span className={styles.checkboxText}>
                        {getI18n('storeProductSetting.detail.uniqueValue')}
                      </span>
                    </Checkbox>
                  </Form.Item>
                );
            }
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PriceTierModalForm;
